export default __webpack_public_path__ + "_/_/node_modules/@pf-loan-funnel/pf-component-library/lib/assets/question-icon-2d5e5f9d2e8804adbe7fa102fbb29cde.svg";